//export const API_URL = 'http://localhost:5000/';
export const API_URL = 'https://t4uk-api.techwagger.com/';   /// Stagging
//export const API_URL = 'https://t3-api-demo.greduation.com/';    /// Demo 
//export const API_URL = 'https://api.t3amb.info/';    /// Production



